module.exports = {"410202001":"北书店街道","410202002":"午朝门街道","410202003":"大兴街道","410202005":"北道门街道","410202006":"城西街道","410202007":"梁苑街道","410202008":"宋城","410202009":"新城街道","410202100":"杏花营镇","410202201":"北郊乡","410202202":"柳园口乡","410202203":"西郊乡","410202204":"水稻乡","410202400":"杏花营农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410202.json
// module id = 1528
// module chunks = 0